
import CommonUtils from "@/common-utils";
import axios from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Raffles extends Vue {
}
